import openMasterBuyDialogComponent from './family-plan-master-buy-dialog.component';

export default angular
  .module('fizyweb.paycell.openMasterBuy', [])
  .component('familyPlanMasterBuyDialog', openMasterBuyDialogComponent)
  .name;



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-master-buy-dialog/family-plan-master-buy-dialog.module.ts